import React from 'react'
import PropTypes from 'prop-types'
import LoggedOutNav from 'molecules/LoggedOutNav.js'
import LoggedInNav from 'molecules/LoggedInNav.js'
import styled from 'styled-components'
import { ProfileConsumer } from 'contexts/profile-context'
import DataErrorBoundary from 'atoms/DataErrorBoundary'

const Wrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  color: #fff;
`

function MainNavRight(props) {
  if (props.suppressAuthUI === true) {
    return null
  }
  return (
    <DataErrorBoundary>
      <Wrapper>
        <ProfileConsumer>
          {(profile) => {
            // handle undecided authentication state
            if (profile.isAuthenticated === null) {
              return null
            }

            if (profile.isAuthenticated === true) {
              return <LoggedInNav bonuses={profile.bonuses} />
            }

            return <LoggedOutNav />
          }}
        </ProfileConsumer>
      </Wrapper>
    </DataErrorBoundary>
  )
}

MainNavRight.propTypes = {
  suppressAuthUI: PropTypes.bool,
}

export default MainNavRight



// WEBPACK FOOTER //
// ./src/organisms/Header/DesktopHeader/components/MainNav/components/MainNavRight.js